window.marmeto = window.marmeto || {};

marmeto.RecentlyViewedProducts = (function() {
  function RecentlyViewedProducts(element) {
    this.container = document.querySelector('[data-section-type="' + element + '"]');
    
    if(!this.container) {
      return;
    }

    const rawSettings = this.container.getAttribute('data-section-settings').replace(/'/g, '"');
    this.options = JSON.parse(rawSettings);

    if (this.options['productId']) {
      this.saveCurrentProduct();
    }
    
    this.fetchProducts();
    this.attachEventListeners();
  }
  
  RecentlyViewedProducts.prototype.attachEventListeners = function() {
    //ADD ANY EVENTLISTENERS LIKE :: ADD TO CART, QUICK VIEW ETC..
  }
  
  RecentlyViewedProducts.prototype.fetchProducts = function() {
    const _this = this;   
    const queryString = this.getSearchQueryString();

    if (queryString === '') {
      _this.container.classList.add('hidden');
      return;
    }

    fetch(("/search?view=mm-recently-viewed&type=product&q=").concat(queryString), {
      credentials: 'same-origin',
      method: 'GET'
    })
    .then(function (response) {
      return response.text();
    })
    .then(function (content) {
      const blankDivElement = document.createElement('div');
      blankDivElement.innerHTML = content;
      
      const sourceContainer = blankDivElement.querySelector('[data-section-type="mm-recently-viewed-products"] .mm-recentlyviewed__container');
      const targetContainer = _this.container.querySelector('.mm-recentlyviewed__container');

      if (sourceContainer && targetContainer) {
        targetContainer.innerHTML = sourceContainer.innerHTML;
        _this.container.parentNode.style.display = 'block';
        _this.container.querySelector('carousel-component').initCarousel();
      } else {
        console.error('Source or target container not found');
      }
    })
    .catch(function (error) {
      console.error('Error fetching recently viewed products:', error);
    })
    .finally(() => {
      const customEvent = new Event('quick-add');
      document.dispatchEvent(customEvent);
    })
  }
  
  RecentlyViewedProducts.prototype.saveCurrentProduct = function() {
    /*
     * - Check if the current product already exists, and if it does not, add it at the start
     * - Then, we save the current product into the local storage, by keeping only the 18 most recent
    */
    let items = JSON.parse(localStorage.getItem('mmRecentlyViewedProducts')) || [];
    const productId = this.options['productId']; 

    if (!Array.isArray(items)) {
      items = [];
    }

    const recentlyViewedTab = document.querySelector("button[data-tab='recently-viewed']");

    if (items.length === 0 || (items.length === 1 && items.includes(productId))) {
      if (recentlyViewedTab) recentlyViewedTab.classList.add("hidden");
    } else {
      if (recentlyViewedTab) recentlyViewedTab.classList.remove("hidden");
    }

    if (!items.includes(productId)) {
      if (items.length == 5) {
        items.pop(); // Remove the last item because the limit to save is 5
      }
      items.unshift(productId);
    }

    try {
      localStorage.setItem('mmRecentlyViewedProducts', JSON.stringify(items));
    } 
    catch (error) {
      console.error('Error saving recently viewed products:', error);
    }
  }
  
  RecentlyViewedProducts.prototype.getSearchQueryString = function() {
    let items = JSON.parse(localStorage.getItem('mmRecentlyViewedProducts')) || [];
    
    if (!Array.isArray(items)) {
      items = [];
    }

    if (items.includes(this.options['productId'])) {
      items.splice(items.indexOf(this.options['productId']), 1);
    }

    return items.map(function (item) {
      return 'id:' + item;
    }).join(' OR ');
  }
  
  RecentlyViewedProducts.prototype.initSlider = function() {
    //INITIALIZE THE SLIDER HERE
    //PARENT ELEMENT IS :: .mm-recentlyviewed__products
  }
  
  return RecentlyViewedProducts;
})();

new marmeto.RecentlyViewedProducts('mm-recently-viewed-products');